import { ActionItemCountData } from './action-item-count-data';

export interface ActionItemTotalCountData {
  totalCount: number;
  items: ActionItemCountData[];
}
